import { Type, type Static } from "@sinclair/typebox";
const uuid = Type.String({ format: "uuid" });
export const EmployeeDeadlineSaveSchema = Type.Object(
  {
    operationId: uuid,
    id: Type.Optional(uuid),
    version: Type.Optional(Type.Integer({ minimum: 1 })),
    employeeId: uuid,
    documentName: Type.String({ minLength: 1, maxLength: 240 }),
    category: Type.Union([
      Type.Literal("certificates"),
      Type.Literal("identity"),
      Type.Literal("other"),
    ]),
    expiresOn: Type.String({ format: "date" }),
    sourceFingerprint: Type.String({ pattern: "^[a-f0-9]{64}$" }),
    sourcePage: Type.Integer({ minimum: 1, maximum: 20 }),
    method: Type.Union([Type.Literal("pdf"), Type.Literal("ocr")]),
  },
  { additionalProperties: false },
);
export type EmployeeDeadlineSave = Static<typeof EmployeeDeadlineSaveSchema>;
export const EmployeeDeadlineChangeSchema = Type.Object(
  {
    operationId: uuid,
    version: Type.Integer({ minimum: 1 }),
    action: Type.Union([Type.Literal("renew"), Type.Literal("cancel")]),
    expiresOn: Type.Optional(Type.String({ format: "date" })),
  },
  { additionalProperties: false },
);
export type EmployeeDeadlineChange = Static<
  typeof EmployeeDeadlineChangeSchema
>;
export const EmployeeDeadlineQuerySchema = Type.Object(
  {
    employeeId: Type.Optional(uuid),
    from: Type.Optional(Type.String({ format: "date" })),
    to: Type.Optional(Type.String({ format: "date" })),
  },
  { additionalProperties: false },
);
export type EmployeeDeadlineQuery = Static<typeof EmployeeDeadlineQuerySchema>;
export interface EmployeeDocumentDeadline {
  id: string;
  employeeId: string;
  employeeName: string;
  documentName: string;
  category: "certificates" | "identity" | "other";
  expiresOn: string;
  remindOn: string;
  status: "active" | "cancelled";
  version: number;
  sourcePage: number;
  method: "pdf" | "ocr";
}
export interface EmployeeDeadlineOverview {
  enabled: boolean;
  canManage: boolean;
  items: EmployeeDocumentDeadline[];
}
